<template>
  <div class="body_container">
    <Contact></Contact>
    <div class="width_margin">
      <div class="container_content_list_title">리:로케이션</div>
    </div>

    <div class="width_margin">
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication19.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#해외현지지원</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              One-Stop 리:로케이션 서비스
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            해외 파견 시 갖게 되는 두려움과 막연함을 설레임으로 바꿔주는
            현지적응 서비스 지원으로 안정적인 정착을 유도합니다.
          </div>
          <div class="container_content_text_content">
            파견 교육 이후 주거나 생활 서비스에 대한 실질적 지원을 도와 빠른
            적응으로 비즈니스 성공에 집중할 수 있도록 지원하는 목적<br />
            주거/차량 임대 계약, 보험 서비스, 은행 및 휴대폰 개통, 현지 병원
            이슈 해결, 현지 동역 서비스, 자녀교육 컨설팅 및 입학 학교 제안 등<br />
            주재원의 커리어 수립 및 정착, 자녀 학업의 연계 및 컨설팅, 가족의
            생활 서비스 제공 등 다시 자리잡을 수 있도록(리:로케이션) 서포트
          </div>
          <p class="go-site">
            <a href="https://www.expatcare.co.kr/" target="_blank"
              >사이트 바로가기</a
            >
          </p>
        </div>
      </div>

      <!-- <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication24.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#현업 중심</div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">One-Stop 리로케이션 서비스</div>
            <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div>
          </div>
          <div class="container_content_text_title"></div>
          <div class="container_content_text_content"></div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Global/ContactUs.vue";
export default {
  components: {Contact},
  name: "Relocationhelp",
};
</script>

<style></style>
